import { useState } from 'react';
import { FaHome, FaInfoCircle, FaBox, FaPhoneAlt, FaBriefcase } from 'react-icons/fa';
import LOGO from '../../assets/image.webp';
import './styles.css';

function NavBar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-white shadow-lg fixed w-full top-0 z-50 border-b-4 border-red-600">
      <div className="container mx-auto px-4 py-3">
        <div className="flex justify-between items-center">
          {/* Logo Section */}
          <div className="flex items-center space-x-2 cursor-pointer" onClick={() => window.location.href = '/'}>
      
            <img 
              src={LOGO}  alt="Distribuidora York"
              className="h-14 w-auto" 
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <a href="/sobre-nos" className="flex items-center space-x-1 text-gray-700 hover:text-red-600 font-medium transition">
              <FaInfoCircle size={16} />
              <span>Sobre a York</span>
            </a>
            <a href="/contato" className="flex items-center space-x-1 text-gray-700 hover:text-red-600 font-medium transition">
              <FaPhoneAlt size={16} />
              <span>Contato</span>
            </a>
            <a href="/trabalhe-conosco" className="flex items-center space-x-2 bg-red-600 text-white px-6 py-2 rounded-full hover:bg-red-700 transition font-medium">
              <FaBriefcase size={16} />
              <span>Trabalhe Conosco</span>
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            onClick={toggleMenu}
            className="lg:hidden flex flex-col space-y-1 focus:outline-none"
          >
            <span className={`h-1 w-6 bg-gray-700 transition ${isMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
            <span className={`h-1 w-6 bg-gray-700 transition ${isMenuOpen ? 'opacity-0' : ''}`}></span>
            <span className={`h-1 w-6 bg-gray-700 transition ${isMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden mt-4 pb-4 space-y-3 border-t pt-4">
            <a href="/sobre-nos" className="flex items-center space-x-2 text-gray-700 hover:text-red-600 font-medium transition">
              <FaInfoCircle size={16} />
              <span>Sobre a York</span>
            </a>
            <a href="/contato" className="flex items-center space-x-2 text-gray-700 hover:text-red-600 font-medium transition">
              <FaPhoneAlt size={16} />
              <span>Contato</span>
            </a>
            <a href="/trabalhe-conosco" className="flex items-center justify-center space-x-2 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition font-medium">
              <FaBriefcase size={16} />
              <span>Trabalhe Conosco</span>
            </a>
          </nav>
        )}
      </div>
    </header>
  )
}

export default NavBar;
